

import { IAppointmentStatusRequestParam } from "../models/IAppointmentStatusRequestParam"
import { ForceCloseReason, MISSED_REASON_CODE } from "../utils/AppConstants";

class AppointmentStatusRequestBuilder {

    appointmentStatusRequestParams: IAppointmentStatusRequestParam;

    constructor() {
        this.appointmentStatusRequestParams = {
            status: null
        };
    }
    setStatus(status: string): AppointmentStatusRequestBuilder {
        this.appointmentStatusRequestParams.status = status;
        return this;
    }
    setForcedUpdate(): AppointmentStatusRequestBuilder {
        this.appointmentStatusRequestParams.isForcedUpdate = true;
        return this;
    }
    setReasonCode(reasonCode: ForceCloseReason): AppointmentStatusRequestBuilder {
        this.appointmentStatusRequestParams.reasonCode = reasonCode;
        return this;
    }
    setReasonText(reasonText: string): AppointmentStatusRequestBuilder {
        this.appointmentStatusRequestParams.reasonText = reasonText;
        return this;
    }

    setMissedReasonCode(missedReasonCode: MISSED_REASON_CODE): AppointmentStatusRequestBuilder {
        this.appointmentStatusRequestParams.missedReasonCode = missedReasonCode;
        return this;
    }

    build(): IAppointmentStatusRequestParam {
        return this.appointmentStatusRequestParams;
    }


}

export default AppointmentStatusRequestBuilder